import React, { useState, Fragment } from 'react';
import '../main.scss';
import CardFormInvoiceContainer from './form-invoice'
import CardFormContainer from './form-card/index';
import FeatureTab from '@ui-components/feature-tab';
import Layout from '@ui-components/layout';
import { MANUAL_LINKS } from '@constants';
import language from '@language';

const CardContainer = ({country}) => {
    const [showCardForm, setShowCardForm] = useState(false);
    const [invoiceTransaction, setInvoiceTransaction] = useState({});
    const [amount, setAmount] = useState(0);
 
    const handleInvoiceSubmit = ({transaction, totalAmount}) => {
        if(!transaction || !transaction.id_transaction) return;
        setAmount(totalAmount);
        setShowCardForm(true);
        setInvoiceTransaction(transaction);
    }

    const renderForm = () => {
      return (!showCardForm) ?  
        (<CardFormInvoiceContainer country={country} onSubmit={handleInvoiceSubmit} />):
        (<CardFormContainer 
            country={country} 
            invoiceTransaction={invoiceTransaction} 
            amount={amount} 
            onBack={onBack}
            />)
    }

    const onBack = () => {
        setShowCardForm(false);
    }

    let tabCardForm = [
        {
            title: language.card.tab_title,
            id: 'card-method',
            icon: 'fa fa-credit-card',
            content: renderForm(),
            className: 'selected card-tab',
            iconBack: (showCardForm) ? 'fa-arrow-left' : '',
            onBack
        }
    ];

    return (
        <Layout country={country} manual={MANUAL_LINKS[country]}>
            <div className="payments-container">
                <FeatureTab options={tabCardForm}/>
            </div>
        </Layout> 
    );
}

export default CardContainer;